import { render, staticRenderFns } from "./retail_hotel_card.vue?vue&type=template&id=0be05fe4&"
import script from "./retail_hotel_card.vue?vue&type=script&lang=js&"
export * from "./retail_hotel_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports